<app-dialog-popup #dialog>
  <div dialog-header>
    <span>clang-format config migrate options</span>
  </div>
  <div dialog-body>
    <dl>
      <dt>Initial version:</dt>
      <dd>
        <select [(ngModel)]="oldVersion" (change)="forceMigrate()">
          <option value="min">Lowest compatible</option>
          <option value="max">Newest compatible</option>
          @for (version of compatibleVersions(); track version) {
            <option [value]="version.name">{{ version.name }}
            </option>
          }
        </select>
      </dd>
      <dt>Final version:</dt>
      <dd>
        <select [(ngModel)]="newVersion" (change)="updateCompatibleStyles(); forceMigrate()">
          <option value="V3_3">V3.3</option>
          <option value="V3_4">V3.4</option>
          <option value="V3_5">V3.5</option>
          <option value="V3_6">V3.6</option>
          <option value="V3_7">V3.7</option>
          <option value="V3_8">V3.8</option>
          <option value="V3_9">V3.9</option>
          <option value="V4">V4</option>
          <option value="V5">V5</option>
          <option value="V6">V6</option>
          <option value="V7">V7</option>
          <option value="V8">V8</option>
          <option value="V9">V9</option>
          <option value="V10">V10</option>
          <option value="V11">V11</option>
          <option value="V12">V12</option>
          <option value="V13">V13</option>
          <option value="V14">V14</option>
          <option value="V15">V15</option>
          <option value="V16">V16</option>
          <option value="V17">V17</option>
          <option value="V18">V18</option>
          <option value="V19">V19</option>
          <option value="V20">V20</option>
          <option value="V21">V21</option>
          <option value="V22">V22</option>
          <option value="V23">V23</option>
        </select>
      </dd>
      <dt>Fallback BasedOnStyle (if missing in input config or<br />unavailable in older version while downgrading):</dt>
      <dd>
        <select [(ngModel)]="defaultStyle" (change)="forceMigrate()">
          @for (style of compatibleStyles(); track style) {
            <option [value]="style">{{ style }}
            </option>
          }
        </select>
      </dd>
      <dt>Export only changed value:</dt>
      <dd>
        <input name="exportOnlyChangedValue" type="checkbox" [(ngModel)]="exportOnlyChangedValue"
          (change)="forceMigrate()"><br />
      </dd>
    </dl>
  </div>
</app-dialog-popup>

<app-textarea-two inputPlaceholder="Enter clang-format config here" [inputChange]="migrate">
  <div header-input>
    <h2>Initial clang-format config</h2>
  </div>
  <div header-output>
    <h2>Migrated clang-format config<lucide-icon name="settings" (click)="openSettings()" /></h2>
  </div>
</app-textarea-two>

@if (isLoading()) {
  <app-spinner-loading [size]="spinnerSize()" [title]="titleLoading" />
}
<a href="https://github.com/bansan85/web-demangler">
  <app-github-mark-inline class="github_logo" />
</a>